import debounce from 'lodash-es/debounce'

function setViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight();

window.addEventListener('resize', debounce(setViewportHeight, 100, {
  trailing: true,
}));
